import { render, staticRenderFns } from "./SaActionButton.vue?vue&type=template&id=0ae6c116&"
import script from "./SaActionButton.vue?vue&type=script&lang=js&"
export * from "./SaActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports